"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 8C4 5.79086 5.79086 4 8 4H88C90.2091 4 92 5.79086 92 8V12V84V88C92 90.2091 90.2091 92 88 92H8C5.79086 92 4 90.2091 4 88V84V12V8ZM12 84H84V68H12V84ZM12 12H84V60H12V12Z"
}), '0 0 96 96');